// src/App.js
import { Routes, Route, Navigate } from "react-router-dom";
import LoginForm from "./components/LoginForm";
import Dashboard from "./pages/Dashboard";
import ProGestao from "./pages/ProGestao";
import NucleoEditPage from "./pages/NucleoEditPage";
import ShapefileUploadPage from "./pages/ShapefileUploadPage";

import { useAuth } from "./context/AuthContext";
function App() {
  const { isLoggedIn, login, isLoading } = useAuth();

  if (isLoading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <p>Autenticando...</p>
        </div>
      );
    }

  if (!isLoggedIn) return <LoginForm onLogin={login} />;
  return (
    <Routes>

      {/* Rota do Dashboard atualizado que você enviou */}
      <Route path="/" element={<Dashboard />} />

      {/* Rota para a nova página ProGestão */}
      <Route path="/progestao" element={<ProGestao />} />
      <Route path="/nucleo-editar/:id" element={<NucleoEditPage />} />
      <Route path="/enviar-shape" element={<ShapefileUploadPage />} />

      {/* Rota de fallback caso o endereço não exista */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;